import React from 'react';
import { useProductsList } from './presenter';
import { ProductsListView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const ProductsIndexPage: React.FC<Props> = ({ navigate }) => {
  const vm = useProductsList();
  const confirm = useConfirm();
  const toast = useToast();

  return (
    <ProductsListView
      data={vm.items}
      total={vm.total}
      page={vm.page}
      pageSize={vm.pageSize}
      setPage={vm.setPage}
      setPageSize={vm.setPageSize}
      query={vm.query}
      setQuery={vm.setQuery}
      loading={vm.loading}
      error={vm.error}
      onCreate={() => navigate({ name: 'products/create' })}
      onView={id => navigate({ name: 'products/view', params: { id: String(id) } })}
      onEdit={id => navigate({ name: 'products/update', params: { id: String(id) } })}
      onDelete={async id => {
        const ok = await confirm({ title: 'Delete Product', message: 'Are you sure you want to delete this product?', confirmText: 'Delete', variant: 'destructive' });
        if (!ok) return;
        await vm.remove(Number(id));
        toast.success('Product deleted');
      }}
    />
  );
};

export default ProductsIndexPage;
